// extracted by mini-css-extract-plugin
export var alignCenter = "_80-d";
export var bannerShown = "_80-6";
export var buttonContent = "_80-0";
export var cardList = "_80-1";
export var centerContent = "_80-2";
export var chevron = "_80-3";
export var closePanelButton = "_80-k";
export var conversationContextContainer = "_80-l";
export var conversationDetailContainer = "_80-4";
export var detailWrapper = "_80-7";
export var dropdownButton = "_80-e";
export var dropdownTitle = "_80-9";
export var fullHeight = "_80-5";
export var hidden = "_80-a";
export var icon = "_80-b";
export var mergeSuggestionWrapper = "_80-m";
export var panel = "_80-i";
export var portalButtonsWrapper = "_80-c";
export var right = "_80-j";
export var tableSummaryContainer = "_80-8";
export var tableSummaryHeader = "_80-g";
export var threeDotsButton = "_80-f";
export var wide = "_80-h";